
import React from "react";
import qs from "query-string";
import { actions } from "@gsd/redux-store-backoffice";
import { connect } from "react-redux";
import { Dispatch } from "redux";

const {
  account: {
    creators: { login }
  }
} = actions;

const mapDispatchToProps = (dispatch: Dispatch) => ({
  login: (payload: unknown) => dispatch(login(payload))
});

type AutoLoginHandlerProps = ReturnType<typeof mapDispatchToProps>;
class AutoLoginHandler extends React.Component<AutoLoginHandlerProps> {
  async componentDidMount() {
    const loginQuery = qs.parse(window.location.search);
    if (loginQuery && loginQuery.token) {
      try {
        this.props.login({ token: loginQuery.token });
      } catch (err: unknown) {
        console.error("Unable to login due to " + err);
      }
      return;
    }
  }

  render() {
    return null;
  }
}

export default connect(
  null,
  mapDispatchToProps
)(AutoLoginHandler);
